import React, {useState, useEffect, useRef} from 'react';
import {Form, Input, Button, Card, message, Select, Switch} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import axios from 'axios';
import MathText from "../../components/MathText";
import {API_BASE_URL} from "../../config";
import FileUploader from "../../components/FileUploader";
import '../Styles.css';

const EditSatQuestion = () => {

    const contentRef = useRef(null);
    const leftRef = useRef(null);
    const [contentSel, setContentSel] = useState({start: 0, end: 0});
    const [leftSel, setLeftSel] = useState({start: 0, end: 0})
    const [form] = Form.useForm();
    const [qContent, setQContent] = useState('');
    const [leftsideText, setLeftsideText] = useState('');
    const [qVariant1, setQVariant1] = useState('');
    const [qVariant2, setQVariant2] = useState('');
    const [qVariant3, setQVariant3] = useState('');
    const [qVariant4, setQVariant4] = useState('');
    const [writable, setWritable] = useState(false);
    const [split, setSplit] = useState(false);
    const navigate = useNavigate();
    const {collection_id, question_id, step} = useParams();

    const insertAtSelection = (value, insert, sel) => {
        const s = Math.max(0, Math.min(sel?.start ?? value.length, value.length));
        const e = Math.max(0, Math.min(sel?.end ?? value.length, value.length));
        return value.slice(0, s) + insert + value.slice(e);
    };
    const focusAndSetCaret = (ref, pos) => {
        const el = ref.current?.resizableTextArea?.textArea || ref.current;
        if (el) {
            el.focus();
            try {
                el.setSelectionRange(pos, pos);
            } catch {
            }
        }
    };

    // Ma'lumotlarni yuklash
    useEffect(() => {
        const fetchData = async () => {
            try {
                const {data} = await axios.get(`${API_BASE_URL}/api/SatQuestion/${question_id}`);
                // Fieldlarni to'g'ri bo'lishi uchun:
                setQContent(data.content || '');
                setLeftsideText(data.leftsideText || '');
                setQVariant1(data.variant1 || '');
                setQVariant2(data.variant2 || '');
                setQVariant3(data.variant3 || '');
                setQVariant4(data.variant4 || '');
                setWritable(!!data.writable);
                setSplit(!!data.split);

                // Content + variantlarni A) B) C) D) bilan birlashtirib textarea ga qo'yish
                const labels = ['A)', 'B)', 'C)', 'D)'];
                const variants = [data.variant1, data.variant2, data.variant3, data.variant4];
                const hasVariants = !data.writable && variants.some(v => v);
                const combinedContent = hasVariants
                    ? [data.content, ...variants.map((v, i) => v ? `${labels[i]} ${v}` : null).filter(Boolean)].join('\n\n')
                    : data.content || '';
                form.setFieldsValue({...data, content: combinedContent});
            } catch (error) {
                message.error('Error loading question');
            }
        };
        fetchData();
    }, [question_id, form]);

    const refactorContent = (content) => {
        if (content.includes("\n\n")) {
            const parts = content
                .split(/\n{2,}/)
                .map(part => part.trim())
                .filter(Boolean);

            const fieldsToUpdate = {};

            if (parts.length > 0) {
                setQContent(parts[0]);
            }
            const stripLabel = (text, label) => text.startsWith(label + ' ') ? text.slice(label.length + 1) : text.startsWith(label) ? text.slice(label.length) : text;
            if (parts.length > 1) {
                setQVariant1(stripLabel(parts[1], 'A)'));
            }
            if (parts.length > 2) {
                setQVariant2(stripLabel(parts[2], 'B)'));
            }
            if (parts.length > 3) {
                setQVariant3(stripLabel(parts[3], 'C)'));
            }
            if (parts.length > 4) {
                setQVariant4(stripLabel(parts[4], 'D)'));
            }
            form.setFieldsValue(fieldsToUpdate);
        } else {
            setQContent(content);
        }
    };

    const onValuesChange = (changedValues) => {
        if ('content' in changedValues) {
            refactorContent(changedValues.content);
        }
        if ('leftsideText' in changedValues) {
            setLeftsideText(changedValues.leftsideText);
        }
        if ('writable' in changedValues) {
            setWritable(changedValues.writable);
        }
        if ('split' in changedValues) {
            setSplit(changedValues.split);
        }
    };

    const handleImageInsertLeftsideText = (file_name) => {
        const insert = `$\\includegraphics[width=0.4\\textwidth]{${file_name}}$`;
        const currentText = form.getFieldValue('leftsideText') || '';
        const updatedText = insertAtSelection(currentText, insert, leftSel);
        form.setFieldsValue({leftsideText: updatedText});
        setLeftsideText(updatedText);
        const caret = (leftSel?.start ?? currentText.length) + insert.length;
        setTimeout(() => focusAndSetCaret(leftRef, caret), 0);
    };

    const handleImageInsert = (file_name) => {
        const insert = `$\\includegraphics[width=0.4\\textwidth]{${file_name}}$`;
        const currentContent = form.getFieldValue('content') || '';
        const updatedContent = insertAtSelection(currentContent, insert, contentSel);
        form.setFieldsValue({content: updatedContent});
        setQContent(updatedContent);
        const caret = (contentSel?.start ?? currentContent.length) + insert.length;
        setTimeout(() => focusAndSetCaret(contentRef, caret), 0);
    };

    const updateContentSel = (e) => setContentSel({start: e.target.selectionStart, end: e.target.selectionEnd});
    const updateLeftSel = (e) => setLeftSel({start: e.target.selectionStart, end: e.target.selectionEnd});


    const onFinish = async (values) => {
        try {
            values['content'] = qContent;
            values['leftsideText'] = leftsideText;
            values['variant1'] = qVariant1;
            values['variant2'] = qVariant2;
            values['variant3'] = qVariant3;
            values['variant4'] = qVariant4;
            values['writable'] = writable;
            values['split'] = split;
            await axios.put(`${API_BASE_URL}/api/SatQuestion/${question_id}`, {
                ...values, satCollectionId: parseInt(collection_id, 10), step: step,
            });
            message.success('Question updated');
            navigate(`/sat-collection/${collection_id}/questions?tab=${step}`);
        } catch (error) {
            message.error('Failed to update question');
        }
    };

    return (<Card title="Edit Question" style={{margin: 'auto'}}>
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onValuesChange={onValuesChange}
        >
            <div className="flex-form-row">
                <Form.Item name="split" label="Split" valuePropName="checked">
                    <Switch checked={split} onChange={setSplit}/>
                </Form.Item>
                <Form.Item name="writable" label="Writable" valuePropName="checked" style={{paddingLeft: "50px"}}>
                    <Switch checked={writable} onChange={setWritable}/>
                </Form.Item>
            </div>
            <div className="flex-form-row">
                {split ? <Form.Item
                    name="leftsideText"
                    style={{flex: 1}}
                    label={<div style={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10
                    }}>
                        <label style={{fontWeight: 500, paddingRight: 20}}>
                            Leftside Text
                        </label>
                        <FileUploader setImage={handleImageInsertLeftsideText}/>
                    </div>}
                    rules={[{required: false}]}
                >
                    <Input.TextArea
                        ref={leftRef}
                        rows={12}
                        placeholder="Enter leftside text"
                        onSelect={updateLeftSel}
                        onClick={updateLeftSel}
                        onKeyUp={updateLeftSel}
                    />
                </Form.Item> : ""}
                <Form.Item
                    name="content"
                    style={{flex: 1}}
                    label={<div style={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10
                    }}>
                        <label style={{fontWeight: 500, paddingRight: 20}}>
                            Content
                        </label>
                        <FileUploader setImage={handleImageInsert}/>
                    </div>}
                    rules={[{required: true}]}
                >
                    <Input.TextArea
                        ref={contentRef}
                        rows={12}
                        placeholder="Enter question content"
                        onSelect={updateContentSel}
                        onClick={updateContentSel}
                        onKeyUp={updateContentSel}
                    />
                </Form.Item>
            </div>
            <div className="flex-form-row">
                {split ? <div style={{flex: 1, marginRight: 8}}><MathText text={leftsideText}/>
                </div> : ""}
                <div style={{flex: 1}}>
                    <MathText text={qContent}/>
                    <br/>
                    {writable ? (<Form.Item
                        name='answer'
                        label='Answer'
                        rules={[{required: true}]}
                    >
                        <Input placeholder="Paste here answer or answers. For example: ans1;ans2;"/>
                    </Form.Item>) : (<>
                        <MathText text={`A) ${qVariant1}`}/><br/>
                        <MathText text={`B) ${qVariant2}`}/><br/>
                        <MathText text={`C) ${qVariant3}`}/><br/>
                        <MathText text={`D) ${qVariant4}`}/><br/>
                        <Form.Item
                            name="answer"
                            label="Answer"
                            rules={[{required: true}]}
                        >
                            <Select placeholder="Select correct answer">
                                <Select.Option value="A">A</Select.Option>
                                <Select.Option value="B">B</Select.Option>
                                <Select.Option value="C">C</Select.Option>
                                <Select.Option value="D">D</Select.Option>
                            </Select>
                        </Form.Item>
                    </>)}
                </div>
            </div>
            <Form.Item
                key='link'
                name='link'
                label='Video link'
                rules={[{required: false}]}
            >
                <Input placeholder={`Paste here video url from telegram`}/>
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Update Question</Button>
            </Form.Item>
            <Form.Item>
                <Button onClick={() => navigate(`/sat-collection/${collection_id}/questions?tab=${step}`)}>
                    Cancel
                </Button>
            </Form.Item>
        </Form>
    </Card>);
};

export default EditSatQuestion;
